// src/app/services/notification-update.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationUpdateService {
  private notificationReadSource = new Subject<void>();
  
  // Observable for components to subscribe to
  notificationRead$ = this.notificationReadSource.asObservable();

  // Call this method when notifications are read
  notifyNotificationRead(): void {
    this.notificationReadSource.next();
  }
}